/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core Libraries
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Custom Modules
import { AemModule } from '@core/aem/aem.module';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { SharedBrowseModule } from '@experience/shop/shared-browse/shared-browse.module';

// Components
import { SelectedPlanComponent } from '@experience/shop/product-selector/components/selected-plan/selected-plan.component';
import { DeviceSectionComponent } from '@experience/shop/product-selector/components/device-section/device-section.component';
import { ServiceSectionComponent } from '@experience/shop/product-selector/components/service-section/service-section.component';
import { ByodDeviceSectionComponent } from '@experience/shop/product-selector/components/byod-device-section/byod-device-section.component';

import { AccessoryProductOfferingsComponent } from '@experience/shop/product-selector/components/accessory-product-offerings/accessory-product-offerings.component';
// Routes
import { PRODUCT_SELECTOR_ROUTES } from '@experience/shop/product-selector/product-selector.routes';

// Services
import { ProductSelectorService } from '@experience/shop/product-selector/services/product-selector.service';
import { SoftgoodsService } from '@experience/shop/softgoods/services/softgoods.service';
import { PurchasePathService } from '@experience/shop/services/purchase-path.service';
import { BrowseHardgoodsService } from '@experience/shop/hardgoods/services/browse-hardgoods.service';
import { LineCarouselComponent } from '@experience/shop/product-selector/components/line-carousel/line-carousel.component';
import { AddRemoveLineComponent } from '@experience/shop/product-selector/components/add-remove-line/add-remove-line.component';
import { LineSummaryComponent } from '@experience/shop/product-selector/components/line-summary/line-summary.component';
import { ProductDetailsService } from '@experience/shop/services/product-details.service';
import { ProductSummaryComponent } from '@experience/shop/product-selector/components/product-summary/product-summary.component';
import { LineDetailComponent } from '@experience/shop/product-selector/components/selected-line-details/selected-line-details.component';
import { PrePurchasedPlanComponent } from '@experience/shop/product-selector/components/pre-purchased-plan/pre-purchased-plan.component';
import { ProductSelectorComponent } from '@experience/shop/product-selector/components/product-selector.component';
import { ProductSelectorLandingComponent } from '@experience/shop/product-selector/components/product-selector-landing/product-selector-landing.component';
import { AccessorySectionModule } from '@experience/shop/accessory-section/accessory-section.module';
import { TabViewModule } from 'primeng/tabview';
import { ServiceDetailsComponent } from '@experience/shop/product-selector/components/service-details/service-details.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    WidgetsModule,
    SharedBrowseModule,
    AemModule,
    AccessorySectionModule,
    TabViewModule,
    RouterModule.forChild(PRODUCT_SELECTOR_ROUTES),
  ],
  declarations: [
    ProductSelectorLandingComponent,
    ServiceSectionComponent,
    SelectedPlanComponent,
    DeviceSectionComponent,
    AccessoryProductOfferingsComponent,
    ByodDeviceSectionComponent,
    LineCarouselComponent,
    AddRemoveLineComponent,
    LineSummaryComponent,
    ProductSummaryComponent,
    LineDetailComponent,
    ServiceDetailsComponent,
    PrePurchasedPlanComponent,
    ProductSelectorComponent,
  ],
  providers: [
    ProductSelectorService,
    SoftgoodsService, // @TODO: Why are we providing a new instance of this service here?
    PurchasePathService, // @TODO: Why are we providing a new instance of this service here?
    BrowseHardgoodsService, // @TODO: Why are we providing a new instance of this service here?
    ProductDetailsService, // @TODO: remove this once a shared service is available, needed for device sku scan flow
  ],
  exports: [ServiceSectionComponent],
})
export class ProductSelectorModule {}
